import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ArticleModel} from '../models/article.model';
import {ArticleConverter} from '../converters/article.converter';
import * as _ from 'lodash';
import { ConfigurationService } from '../../shared/services/configuration.service';

@Injectable()
export class ArticlesService {

  constructor(
    private httpClient: HttpClient,
    private articleConverter: ArticleConverter,
    private configurationService: ConfigurationService
  ) {
  }

  getBaseResourceEndpoint(): string {
    return (
      this.configurationService.configuration.api.articles
    );
  }

  // ricerca tutti gli articoli per cliente/account
  public find(unitParams: any): Observable<Array<ArticleModel>> {
    const url = this.getBaseResourceEndpoint();
    return this.httpClient.post(url, unitParams).pipe(
      map((dtos: any) => {
        let toReturn: any = [];
        // ci sta anche domains ma non devono essere visualizzati
        toReturn = _.concat(dtos.pecs, dtos.products);
        return this.articleConverter.convertToModelList(toReturn);
      })
    );
  }

  // ricerca articolo filtrato per tipologia
  public findByType(unitParams: any, article: string, articleType: string): Observable<ArticleModel> {
    const url = this.getBaseResourceEndpoint();
    return this.httpClient.post(url + `/${article}/type/${articleType}`, unitParams).pipe(
      map((dtos: any) => {
        return this.articleConverter.convertToModel(dtos);
      })
    );
  }
}
